import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Typography } from '@comparethemarketau/manor-typography';

const useStyles = createUseStyles((theme) => ({
    brandNoReturnedReasonContainer: {
        fontSize: theme.fontSize.xs,
        fontWeight: theme.fontWeight.normal,
        color: theme.colors.grey700
    }
}));

const BrandNoReturnedReason = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { className } = props;

    return (
        <Typography className={classNames(classes.brandNoReturnedReasonContainer, className)}>
            {'This could be because you don\'t meet their underwriting requirements'}
            {', or perhaps that they may not have a suitable product for you base on the information provided.'}
        </Typography>
    );
};

BrandNoReturnedReason.propTypes = {
    className: PropTypes.string
};

export { BrandNoReturnedReason };
